var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPackage = function SvgPackage(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.425v-6.85L5 9.1v6.85zm2 0 6-3.475V9.1l-6 3.475zm-2 2.3L4 17.7a1.948 1.948 0 0 1-1-1.725v-7.95A1.95 1.95 0 0 1 4 6.3l7-4.025Q11.475 2 12 2t1 .275L20 6.3q.475.275.738.725.262.45.262 1v7.95a1.95 1.95 0 0 1-1 1.725l-7 4.025Q12.525 22 12 22t-1-.275m5-13.2 1.925-1.1L12 4l-1.95 1.125zm-4 2.325 1.95-1.125L8.025 6.3l-1.95 1.125z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPackage);
export { ForwardRef as ReactComponent };